import React from 'react';
import data from '../resources/award.json'
import Table from '../components/table';

const Awards = () => {  
    return (
      <div className="App">
        <h1 style={{
                borderBottom: '2px solid rgb(109, 169, 228)',
                display: 'inline-block',
                marginTop: '45px'
            }}>Awards</h1>
        <Table data={data} text={'View'}/>
      </div>
    );
  };
  
  export default Awards;